import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { CHECKBOX_TRADE_DISCOUNT } from '../../../../../cartAndOrders/constant'
import {
  selectCheckDisCountAndVoucher,
  selectDiscountOrder,
  selectVoucher,
} from '../../../../../cartAndOrders/store/slice'
import useGetVAT from '../../../../../common/category/useVAT'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import classes from '../../../../index.module.scss'
import {
  selectBuyPackage,
  selectSubscriptionPurchasedPrice,
  setListPackage,
} from '../../../store/slice'
import { formatPrice } from '../../helper'
import { PackageItem } from '../../popupBuyPackage/common/PackageItem'
import { Price } from '../../popupBuyPackage/common/price'

export const BuyPackage = ({ subscriptionType, propsSub }) => {
  const dispatch = useDispatch()

  const buyPackage = useSelector(selectBuyPackage)
  const subscriptionPurchasedPrice = useSelector(
    selectSubscriptionPurchasedPrice,
  )
  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)
  const dataVoucher = useSelector(selectVoucher)
  const discountOrderDefault = useSelector(selectDiscountOrder)
  const { vatPercentage } = useGetVAT()

  const discountOrder = propsSub
    ? propsSub?.discountPackage
    : discountOrderDefault

  // Packages
  const listPackage = buyPackage?.listPackage
  const totalPackagePrice =
    listPackage
      ?.map((item) => item.totalPrice)
      .reduce((sum, acc) => sum + acc, 0) || 0
  const totalPackageDiscountProduct =
    listPackage
      ?.map((item) => item.totalPrice * (item.discountPercentage || 0))
      .reduce((sum, acc) => sum + acc, 0) || 0
  const totalPackageDiscountOrder =
    (totalPackagePrice - totalPackageDiscountProduct) *
    (discountOrder?.discountPercentage || 0)
  const totalPackageVoucher = checkDiscountAndVoucher[
    CHECKBOX_TRADE_DISCOUNT.VOUCHER
  ]
    ? (totalPackagePrice - totalPackageDiscountProduct) *
      dataVoucher?.discountPercentage
    : 0

  // Total
  const totalPrice = totalPackagePrice + subscriptionPurchasedPrice
  const totalDiscountOrder =
    propsSub?.discountOderOnlySub +
    propsSub?.voucherOrderOnlySub +
    formatPrice(totalPackageDiscountOrder + totalPackageVoucher)
  const totalNotIncludedVAT =
    totalPrice - totalDiscountOrder - totalPackageDiscountProduct
  const totalVatPrice = vatPercentage * totalNotIncludedVAT
  const grandTotalPrice = totalNotIncludedVAT + totalVatPrice

  const onAddBtnClick = () => {
    dispatch(setListPackage([...listPackage, { rowId: listPackage.length }]))
  }

  useEffect(() => {
    dispatch(setListPackage([{ rowId: 0 }]))
  }, [])

  return (
    <>
      <ScrollComponent appendStyle={{ height: 220 }}>
        {listPackage?.map((item, index) => (
          <div key={index}>
            <PackageItem
              itemIndex={index}
              isBuyOnePackage={false}
              classNamePrice={classes.w44}
              subscriptionType={subscriptionType}
            />
            <Element className={classes.dashedLine} />
          </div>
        ))}
      </ScrollComponent>
      <div className="flexColumn">
        <Element
          className={[classes.addNewPackage, 'flexRow'].join(' ')}
          onClick={onAddBtnClick}
        >
          <Icon
            className="icon-plus-circle-fill"
            style={{ fontSize: 15, color: '#2C73E8' }}
          />
          <Element
            elementName="span"
            style={{
              color: '#2C73E8',
              marginLeft: 5,
            }}
          >
            <Translate value="userManagement.buyPackage.ADD_NEW_PACKAGE" />
          </Element>
        </Element>
        <Element
          style={{ backgroundColor: '#FFFFFF' }}
          className={classes.priceTotalContainer}
        >
          <Price
            title="userManagement.buyPackage.TOTAL_PRICE"
            price={totalPrice ?? 0}
            classNamePrice={classes.w44}
          />

          <Price
            title="userManagement.packageSubManagement.TRADE_DISCOUNT"
            price={totalPackageDiscountProduct ?? 0}
            classNamePrice={classes.w44}
          />

          <Price
            title="userManagement.buyPackage.TRADE_DISCOUNT"
            price={totalDiscountOrder}
            classNamePrice={classes.w44}
            isDiscount
            priceDiscountDetails={{
              totalPrice,
              totalPackageDiscountProduct,
              subscription: {
                ...propsSub?.discountSub,
                price: propsSub?.discountOderOnlySub,
              },
              package: {
                ...propsSub?.discountPackage,
                price: totalPackageDiscountOrder,
              },
            }}
          />
          <Price
            title="VAT"
            price={totalVatPrice}
            classNamePrice={classes.w44}
          />
          <Price
            title="userManagement.buyPackage.GRAND_TOTAL"
            price={grandTotalPrice}
            classNamePrice={classes.w44}
          />
        </Element>
      </div>
    </>
  )
}
